var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-dropdown-item',{staticClass:"drop-item",on:{"click":_vm.callAction}},[_c('img',{staticClass:"dropItem",attrs:{"src":require(`@/assets/${_vm.image}`),"alt":`${_vm.altTxt}`}}),_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }